const userGetter = (state) => state.userLoginDetails;
const userDetailsGetter = (state) => state.userDetails;
 
export default {
  userGetter,
  userDetailsGetter,
}


// WEBPACK FOOTER //
// ./src/store/modules/authentication/getters.js